import { useState, useEffect, useCallback } from 'react';
import type { Inquiry } from '../types';
import { inquiryRepository } from '../data/inquiryRepository';

/**
 * useInquiryDetail フックの戻り値
 */
interface UseInquiryDetailReturn {
  data: Inquiry | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

/**
 * お問い合わせ詳細を取得するフック
 */
export const useInquiryDetail = (id: string, token?: string): UseInquiryDetailReturn => {
  const [data, setData] = useState<Inquiry | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const result = await inquiryRepository.getById(id, token);
      if (result.success) {
        if (!result.data) {
          throw new Error('お問い合わせデータが見つかりません');
        }
        setData(result.data);
      } else {
        throw new Error(result.error.message);
      }
    } catch (e) {
      setError(e as Error);
    } finally {
      setIsLoading(false);
    }
  }, [id, token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, isLoading, error, refetch: fetchData };
};
